import { useNavigate } from 'react-router';

// Redux
import { useSelector } from 'react-redux';

// @Utility
import timeZone from "@utility/app/timeZone";
import dateFormatThai from "@utility/app/dateFormatThai";

// Component
import ImageShow from "views/components/ImageShow";
import TimeCount from 'views/components/TimeCount';

// CSS
import homeStyle from "views/pages/home/assets/Home.module.css";
import buttonStyle from "assets/css/Button.module.css";

export default function CardImageYiki({ dataJson }) {
    const reduxAppSetting = useSelector(state => state.reduxAppSetting);
    const history = useNavigate();

    const gotoLottery = () => {
        // if(dataJson.status === 2) {
            history(`/lottory/${dataJson.code}?token=${reduxAppSetting.token}&app_id=${reduxAppSetting.app_id}&code=${reduxAppSetting.code}&language=${reduxAppSetting.lang}&redirect_url=${reduxAppSetting.redirect}`)
        // }
    };

    const checkYear = (date) => {
        if(timeZone(date, "year") < 2023) {
            return false;
        }
        else {
            return true;
        }
    };

    return (
        <div className={[homeStyle.lottoCard, homeStyle.lottoCardActive].join(" ")} onClick={gotoLottery} style={{ opacity: dataJson.status === 2 ? "1" : "0.6" }}>
            <div className={homeStyle.lottoCardImage}>
                {/* lotto_example */}
                <div className="relative">
                    {
                        dataJson?.background === "" ? 
                        <ImageShow className={homeStyle.lottoImg} typeUrl="internal" src="/images/lotto_example.png"></ImageShow>
                        :
                        <ImageShow className={homeStyle.lottoImg} typeUrl="external" src={dataJson?.background}></ImageShow>
                        
                    }
                    
                    <div className={homeStyle.lottoCardImagePosition}>
                        <ImageShow className={homeStyle.lottoCountryImg} typeUrl="external" src="/images/yiki.webp"></ImageShow>
                        
                        <div className={[homeStyle.lottoCardTitle, homeStyle.menuMargin].join(" ")}>
                            {
                                dataJson.name
                            }
                            {/* หวยจับยี่กี */}
                        </div>

                        <div className={[homeStyle.lottoCardText, homeStyle.menuMargin].join(" ")}>
                            {
                                dataJson.status === 2 ?
                                `ปิดรับ : ${ dateFormatThai(timeZone(dataJson.bet_end, "date")) } ${ timeZone(dataJson.bet_end, "time") } น.`
                                :
                                checkYear(dataJson.result_time) ?
                                    `${ dateFormatThai(timeZone(dataJson.result_time, "date")) } ${ timeZone(dataJson.result_time, "time") } น.`
                                    :
                                    'ปิดรับ : รอรอบถัดไป '
                                
                            }
                            {/* ปิดรับ */}
                        </div>
                    </div>
                </div>
            </div>
            <div className={[homeStyle.lottoCardContent, "center"].join(" ")}>
                {
                    dataJson.status === 2 ?
                    <div className={[buttonStyle.btnOutLine, buttonStyle.outLineSuccess, homeStyle.btnFontSize].join(" ")}>
                        <TimeCount dataJson={ dataJson } />
                    </div>
                    :
                    <div className={[buttonStyle.btnOutLine, buttonStyle.outLineInfo, homeStyle.btnFontSize].join(" ")}>
                        {
                            dataJson.status_name
                        }
                        {/* ยังไม่รับแทง */}
                    </div>
                }
            </div>
        </div>
    );
}